import {useRef, useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {fetchConditionSelection} from 'web/redux/actions/ConditionActions';
import enumList from 'web/utils/enumList';

export const useConditionModalControl = () => {
  const dispatch = useDispatch();
  const conditionModalRef = useRef(null);
  const [conditionModalMode, setConditionModalMode] = useState(
    enumList.modalMode.new,
  );

  useEffect(() => {
    if (conditionModalRef.current) {
      conditionModalRef.current = new bootstrap.Modal(
        conditionModalRef.current,
      );
    }
  }, [conditionModalRef]);

  const toggleConditionModal = (show, mode, conditionCode) => {
    if (show) {
      if (conditionCode) dispatch(fetchConditionSelection(conditionCode));

      setConditionModalMode(mode);

      conditionModalRef.current.show();
    } else {
      conditionModalRef.current.hide();
    }
  };

  return {
    conditionModalMode,
    setConditionModalMode,
    conditionModalRef,
    toggleConditionModal,
  };
};
